
'use client';
import { AxiosInstance } from '../utils';
import { useState, useEffect, useRef } from 'react';
import Slider from "react-slick";
import  Spinner from '../../components/Spinner';   


const customOrder = ["Chief Guests", "Inaugural Speakers", "CXO Speakers", "Industry Leaders", "Technical Speakers", "MidSenior", "Junior", "Trainers"];
function getSocialIcons(socialMedia:any)
{
    if(!socialMedia)
    {
        return(<></>);
    }
   return socialMedia.map((smedia : any) => {
return(
    <>
   { smedia.media == "facebook" && <li><a href={smedia.profileurl} title=""><i className="fa fa-facebook"></i></a></li>}
    {smedia.media == "twitter" && <li><a href={smedia.profileurl} title=""><i className="fa fa-twitter"></i></a></li>}
    {smedia.media == "linkedin" && <li><a href={smedia.profileurl} title=""><i className="fa fa-linkedin"></i></a></li>}
    {smedia.media == "instagram" && <li><a href={smedia.profileurl} title=""><i className="fa fa-instagram"></i></a></li>}
    </>
);
    });
}

function getMappingNames(currName: string): string {
    switch (currName) {
      default:
        return currName; // fallback if no match
    }
  }
// Helper: Groups speakers by speakerType
function groupSpeakersByType(data) {
    return data.reduce((acc : any, speaker :  any) => {
      if (speaker?.display == false) return acc; // Skip invisible speakers
      if (!acc[getMappingNames(speaker.speakerType)]) {
        acc[getMappingNames(speaker.speakerType)] = [];
      }
      acc[getMappingNames(speaker.speakerType)].push(speaker);
      return acc;
    }, {});
  }
  
  // Helper: Sorts speakers by numeric priority
  function sortSpeakersByPriority(speakers :  any) {
    return speakers.slice().sort((a : any, b : any) => Number(a.priority) - Number(b.priority));
  }
  
  // Helper: Groups speakers within a speakerType by priority
  function groupSpeakersByPriority(speakers :  any) {
    return speakers.reduce((acc : any , speaker : any) => {
      if (!acc[speaker.priority]) {
        acc[speaker.priority] = [];
      }
      acc[speaker.priority].push(speaker);
      return acc;
    }, {});
  }
  function getSpeakersCard(speakerObj)
  {
      return(
          
    <div className="col-lg-4 col-md-4" >
    <div className="team-detail wow fadeInUp" >
                    <div className="cmntr-img">
                        <div className="hex-deg">
                            <div className="hex-deg">
                                <div className="hex-deg">
                                    <div className="hex-inner">
                                        <img src={speakerObj.image} alt="" />
                                        {/*<a href="#" title="" className="ext-link"><i className="fa fa-link"></i></a>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="team-info">
                        <h3>{speakerObj.name}</h3>
                        <span>{speakerObj.designation}</span> <br/>
                        <span style={{ color: 'black'}}>{speakerObj.company}</span>
                        <ul className="social-line list-inline text-center">
                           {getSocialIcons(speakerObj.socialmedia)}
                        </ul>
                    </div>
                </div>
  </div>  
      );
  }
function SpeakersSlider({ eventcode }: any) {
    
    const [loading, setLoading] = useState(true);
    const [speakersList, setSpeakersList] = useState([]);
    const [speakersListgroupby, setSpeakersListgroupby] = useState({});
   
    let speakersDivArray:any = [];

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const { data: response } = await AxiosInstance.get('/api/getspeakers?eventcode=' + eventcode);

                if (response.result != "Success" || response.data?.length == 0) {
                    // Set empty object to trigger the "no speakers" message
                    setSpeakersListgroupby({});
                    setLoading(false);
                    return;
                }

               const groupeddata =  groupSpeakersByType(response.data);
               setSpeakersListgroupby(groupeddata);
            } catch (error) {
                console.error(error);
                // Set empty object on error to show "no speakers" message
                setSpeakersListgroupby({});
            }
            setLoading(false);
        }
        fetchData();

        return () => {
        }

    }, []);

    var settings = {
        className: "team-sec-details",
        infinite: true,
        slidesToShow: 4,
        swipeToSlide: true,
        slck: true,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    };
    return (

        <section className="team-sec sec-padding" id="speakers" data-scroll-index="4">
        <div className="container">
            <div className="sec-title">
                <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-user fa-stack-1x"></i></span></span>
                <h3>SPEAKERS <small>/ Distinguished Guests and Cyber Security Leaders</small></h3>
            </div> {/* <!--sec-title end--> */}

            <div className="team-sec-details slider-container">
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                   <Spinner  size="medium"/>
                   </div>
                ) : Object.keys(speakersListgroupby).length === 0 ? (
                    <div className="row">
                        <div className="col">
                            <div className="text-center py-5">
                                <h3 className="text-muted">Speakers are being registered!</h3>
                                <p className="text-muted">Stay tuned for exciting announcements about our distinguished speakers and industry leaders.</p>
                            </div>
                        </div>
                    </div>
                ) : (
                    Object.entries(speakersListgroupby).sort((a: any, b : any) => {
                        return customOrder.indexOf(a[0]) - customOrder.indexOf(b[0]);
                    }).map(([speakerType, speakers]) => {
                        const sortedSpeakers = sortSpeakersByPriority(speakers);
                        const groupedByPriority = groupSpeakersByPriority(sortedSpeakers);
                        return (
                            <>
                            <div className="row">
                                <div className="col">
                                <h1 className="sub-title">{speakerType}</h1>
                                </div>
                                </div>
                          <div className="row centerjustify">
                            {(Object.entries(groupedByPriority) as [string, any][] ).map(([priority, prioritySpeakers ]) => (
                              <>
                                  {prioritySpeakers.map((speaker, index) => (
                                    <>{getSpeakersCard(speaker)}</>
                                  ))}
                              </>
                            ))}
                          </div>
                          </>
                        );
                      })
                )}
            </div>

            {/*<div className="spons-dv text-center wow fadeInUp" data-wow-duration="300ms">
                <a href="#" title="" className="btn-default"><i className="fa fa-user"></i> see all speakers</a>
            </div>*/} {/* <!--spons-dv end--> */}
        </div>
    </section> 

        
        
    );
}

export { SpeakersSlider }